// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { Specials, DateRange, Stats, UserSetting } from './types';
import { ProfilePerformanceStats } from './types';

import moment from 'moment';

export interface ActionGetOfferInsightStatsAPI extends Action {
    iddealer?: string;
    dateRange?: DateRange;
}

export const GetOfferInsightStatsAPI = (iddealer?: string, dateRange?: DateRange ): ActionGetOfferInsightStatsAPI => ({
    type: ACTIONS.GET_OFFER_INSIGHTSTATS_API_REQUEST,
    iddealer,
    dateRange
});

export interface ActionGetOfferInsightStatsAPISuccess extends Action {
    stats: Stats
}
export const GetOfferInsightStatsAPISuccess = (stats: Stats): ActionGetOfferInsightStatsAPISuccess => ({
    type: ACTIONS.GET_OFFER_INSIGHTSTATS_API_SUCCESS,
    stats
});

export const GetOfferInsightStatsAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_OFFER_INSIGHTSTATS_API_ERROR,
    error
});


export interface ActionGetProfilePerformanceInsightStatsAPI extends Action {
    iddealer?: string;
    dateRange?: DateRange;
}

export const GetProfilePerformanceInsightStatsAPI = (iddealer?: string, dateRange?: DateRange ): ActionGetProfilePerformanceInsightStatsAPI => ({
    type: ACTIONS.GET_PROFILE_PERFORMANCE_INSIGHTS_API_REQUEST,
    iddealer,
    dateRange
});

export interface ActionGetProfilePerformanceInsightStatsAPISuccess extends Action {
    profilePerformanceStats: ProfilePerformanceStats
}
export const GetProfilePerformanceInsightStatsAPISuccess = (profilePerformanceStats: ProfilePerformanceStats): ActionGetProfilePerformanceInsightStatsAPISuccess => ({
    type: ACTIONS.GET_PROFILE_PERFORMANCE_INSIGHTS_API_SUCCESS,
    profilePerformanceStats
});

export const GetProfilePerformanceInsightStatsAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_PROFILE_PERFORMANCE_INSIGHTS_API_ERROR,
    error
});



export interface ActionGetOfferInsightsAPI extends Action {
    iddealer?: string
    search?: string
    orderby?: string
    filters?: string
    offset?: number
    limit?: number
    dateRange?: DateRange;

}

export const GetOfferInsightsAPI = (iddealer?: string, search?: string, orderby?:string, filters?:string,offset?:number, limit?:number, dateRange?: DateRange ): ActionGetOfferInsightsAPI => ({
    type: ACTIONS.GET_OFFER_INSIGHTS_API_REQUEST,
    iddealer,
    search,
    orderby,
    filters,
    offset,
    limit,
    dateRange
});

export interface ActionGetOfferInsightsAPISuccess extends Action {
    specials: Specials,
    offset?:number
}

export const GetOfferInsightsAPISuccess = (specials: Specials, offset?: number): ActionGetOfferInsightsAPISuccess => ({
    type: ACTIONS.GET_OFFER_INSIGHTS_API_SUCCESS,
    specials,
    offset,
});

export const GetOfferInsightsAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_OFFER_INSIGHTS_API_ERROR,
    error
});


export const OfferInsightsNextPage = () => ({
    type: ACTIONS.OFFER_INSIGHTS_NEXT_PAGE
})

export const OfferInsightsPrevPage = () => ({
    type: ACTIONS.OFFER_INSIGHTS_PREV_PAGE
})

export const OfferInsightsFilterChange = (filters?: string) : ActionGetOfferInsightsAPI=> ({
    type: ACTIONS.OFFER_INSIGHTS_FILTER_CHANGE,
    filters
})

export const OfferInsightsSearchChange = (search?:string) => ({
    type: ACTIONS.OFFER_INSIGHTS_SEARCH_CHANGE,
    search
})

export interface ActionSetRangeDates extends Action {
    datesRange: DateRange|undefined;
}

export const SetRangeDates = (datesRange: DateRange): ActionSetRangeDates => ({
    type: ACTIONS.SET_RANGE_DATES,
    datesRange
});

export interface ActionGetUserSettingsAPI extends Action {
    filter?: string;
    orderby?: string;
}

export const GetUsersSettingsAPI = (filter?: string, orderby?: string): ActionGetUserSettingsAPI => ({
    type: ACTIONS.GET_USER_SETTING_API_REQUEST,
    filter,
    orderby
});

export interface ActionGetUserSettingsAPISuccess extends Action {
    userSettings: UserSetting;
}
export const GetUsesrSettingsAPISuccess = (userSettings: UserSetting): ActionGetUserSettingsAPISuccess => ({
    type: ACTIONS.GET_USER_SETTING_API_SUCCESS,
    userSettings
});

export const GetUsesrSettingsAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_USER_SETTING_API_ERROR,
    error
});

export interface ActionUserSettingsInfoAPI extends Action {
    userInfo: UserSetting
}

export const SaveUserSettingsAPI = (userInfo: UserSetting): ActionUserSettingsInfoAPI => ({
    type: ACTIONS.SAVE_USER_SETTING_API_REQUEST,
    userInfo
});

export const UpdateUserSettingsAPI = (userInfo: UserSetting): ActionUserSettingsInfoAPI => ({
    type: ACTIONS.UPDATE_USER_SETTING_API_REQUEST,
    userInfo
});